import { styled } from '@arpeggi/ui'
import { FC } from 'react'
import { FileError } from '../../../../../utils/forms'
import { IconButton, Spacer } from '../../../../core/Components'
import { CloseIcon, FileCheckIcon, FileCrossIcon } from '../../../../core/icons'
import Text from '../../../../core/Text/Text'

interface FileItemErrorProps {
  fileError: FileError
}

const StyledFileItemContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  backgroundColor: '$gray0400',
  padding: '8px',
  borderRadius: '$12'
})

const FileItemError: FC<FileItemErrorProps> = ({ fileError }) => {
  return (
    <StyledFileItemContainer css={{ backgroundColor: 'rgba(254, 184, 184, 0.2)' }}>
      <FileCrossIcon height="20px" width="20px" style={{ color: '#EE867F', marginRight: '8px' }} />
      <Text size="14" fontWeight="medium">
        {fileError.message}
      </Text>
      <Spacer />
    </StyledFileItemContainer>
  )
}

interface FileItemProps {
  file: File
  handleDelete: (file: File) => void
}

const FileItemSuccess: FC<FileItemProps> = ({ file, handleDelete }) => {
  return (
    <StyledFileItemContainer>
      <FileCheckIcon height="20px" width="20px" style={{ color: '#5EC271', marginRight: '8px' }} />
      <Text size="14" fontWeight="medium">
        {file.name}
      </Text>
      <Spacer />
      <IconButton onClick={() => handleDelete(file)}>
        <CloseIcon color="black" />
      </IconButton>
    </StyledFileItemContainer>
  )
}

export const FileItem = {
  Error: FileItemError,
  Success: FileItemSuccess
}
